import React from "react";
import { Grid, Row, Col } from "react-bootstrap";
import "./Fusszeile.css";

const Fusszeile = () => (
	<Grid fluid={true} componentClass="footer" className="Fusszeile">
		<Row>
			<Col xs={11}>
                © ALMiG Kompressoren GmbH
			</Col>
		</Row>
	</Grid>
);

//Fusszeile.propTypes = {
//}

export default Fusszeile;
